import { Injectable } from '@angular/core';
import { addWithRounding, percentageWithRounding } from 'i2g-yakka';

@Injectable({
  providedIn: 'root',
})
export class CalculatorService {
  constructor() {}

  addWithRounding(a: number, b: number): number {
    return addWithRounding(a, b);
  }

  percentageWithRounding(base: number, percentage: number): number {
    return percentageWithRounding(base, percentage);
  }
}
